module.exports = __webpack_public_path__ + "img/loading2.43ddcdac.gif";